import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import ScriptDetail from '../../components/scriptdetail/ScriptDetail'
export default class ScriptDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <ScriptDetail />
            </div>
        )
    }
}
